exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".list-item-cell-right{min-width:24px;min-height:20px;text-align:right;line-height:1.14em;padding-left:8px}.list-item-cell-right .value{font-size:19px}.list-item-cell-right .unit{font-size:13px;margin-left:3px}.list-item-cell-right .alt-value-unit{font-size:11px;font-weight:400;color:#979892}", ""]);

